import { Routes, Route, Navigate } from 'react-router-dom'
import usePerformanceCleanup from './shared/hooks/usePerformanceCleanup'
import Home from './pages/Home'
import Login from './pages/Login'
import TeamDashboardPage from './pages/teams/dashboard/TeamDashboardPage'
import TeamCreatePage from './pages/teams/TeamCreatePage'
import NodeIndexPage from './pages/nodes/NodeIndexPage'
import NodeCreatePage from './pages/nodes/NodeCreatePage'
import NodeShowPage from './pages/nodes/NodeShowPage'
import DomainIndexPage from './pages/networking/domains/DomainIndexPage'
import ProjectIndexPage from './pages/docker/projects/ProjectIndexPage'
import ProjectShowPage from './pages/docker/projects/ProjectShowPage'
import ProjectCreatePage from './pages/docker/projects/ProjectCreatePage'
import ProjectEditPage from './pages/docker/projects/ProjectEditPage'
import LogsIndexPage from './pages/docker/logs/LogsIndexPage'
import NetworkIndexPage from './pages/docker/networks/NetworkIndexPage'
import RegistryIndexPage from './pages/docker/registries/RegistryIndexPage'
import ServiceShowPage from './pages/docker/services/ServiceShowPage'
import ServiceCreatePage from './pages/docker/services/ServiceCreatePage'
import MarketplaceIndexPage from './pages/packages/marketplace/MarketplaceIndexPage'
import PackageImportIndexPage from './pages/docker/package-imports/PackageImportIndexPage'
import PackageImportShowPage from './pages/docker/package-imports/PackageImportShowPage'
import TaskIndexPage from './pages/tasks/TaskIndexPage'
import TerminalIndexPage from './pages/operations/terminal/TerminalIndexPage'
import MonitoringIndexPage from './pages/operations/monitoring/MonitoringIndexPage'
import HetznerIndexPage from './pages/cloud/hetzner/HetznerIndexPage'
import HetznerProjectCreatePage from './pages/cloud/hetzner/HetznerProjectCreatePage'
import HetznerServerCreatePage from './pages/cloud/hetzner/HetznerServerCreatePage'
import UserSettingsPage from './pages/settings/UserSettingsPage'
import System from "./system/System.jsx"
import AppLayout from './layouts/AppLayout'
import TeamLayout from './layouts/TeamLayout'
import ProjectLayout from './layouts/ProjectLayout'
import ServiceLayout from './layouts/ServiceLayout'
import NavigationHandler from './shared/components/NavigationHandler'

function App() {
  usePerformanceCleanup()

  return (
    <System>
      <NavigationHandler />
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/teams/new" element={<TeamCreatePage />} />
        </Route>

        <Route path="/teams/:teamSlug" element={<TeamLayout />}>
          <Route index element={<TeamDashboardPage />} />
          <Route path="profile" element={<UserSettingsPage />} />
          <Route path="tasks" element={<TaskIndexPage />} />
          <Route path="nodes" element={<NodeIndexPage />} />
          <Route path="nodes/new" element={<NodeCreatePage />} />
          <Route path="nodes/:nodeId" element={<NodeShowPage />} />
          <Route path="nodes/:nodeId/statistics" element={<NodeShowPage />} />
          <Route path="nodes/:nodeId/networking" element={<NodeShowPage />} />
          <Route path="nodes/:nodeId/features" element={<NodeShowPage />} />
          <Route path="networking/domains" element={<DomainIndexPage />} />
          <Route path="cloud/hetzner" element={<HetznerIndexPage />} />
          <Route path="cloud/hetzner/projects/new" element={<HetznerProjectCreatePage />} />
          <Route path="cloud/hetzner/servers/new" element={<HetznerServerCreatePage />} />
          <Route path="docker/logs" element={<LogsIndexPage />} />
          <Route path="docker/networks" element={<NetworkIndexPage />} />
          <Route path="docker/registries" element={<RegistryIndexPage />} />
          <Route path="docker/projects" element={<ProjectIndexPage />} />
          <Route path="docker/package-imports" element={<PackageImportIndexPage />} />
          <Route path="docker/package-imports/:packageImportId" element={<PackageImportShowPage />} />
          <Route path="packages/marketplace" element={<MarketplaceIndexPage />} />
          <Route path="operations/terminal" element={<TerminalIndexPage />} />
          <Route path="operations/monitoring" element={<MonitoringIndexPage />} />
          <Route path="docker/projects/new" element={<ProjectCreatePage />} />

          <Route path="docker/projects/:projectSlug" element={<ProjectLayout />}>
            <Route index element={<ProjectShowPage />} />
            <Route path="ingress-controllers" element={<ProjectShowPage />} />
            <Route path="deployments" element={<ProjectShowPage />} />
            <Route path="yaml" element={<ProjectShowPage />} />
            <Route path="networks" element={<ProjectShowPage />} />
            <Route path="files" element={<ProjectShowPage />} />
            <Route path="edit" element={<ProjectEditPage />} />
            <Route path="services" element={<Navigate to=".." replace />} />
            <Route path="services/new" element={<ServiceCreatePage />} />

            <Route path="services/:serviceSlug" element={<ServiceLayout />}>
              <Route index element={<ServiceShowPage />} />
              <Route path="settings" element={<Navigate to=".." replace />} />
              <Route path="configuration" element={<ServiceShowPage />} />
              <Route path="storage" element={<ServiceShowPage />} />
              <Route path="networking" element={<ServiceShowPage />} />
              <Route path="cron-jobs" element={<ServiceShowPage />} />
              <Route path="logs" element={<ServiceShowPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </System>
  )
}

export default App
